import { useState,useEffect,useRef  } from 'react';
import { ErrorMessage } from '@hookform/error-message';
import { useForm } from 'react-hook-form';
import { matchPath, useNavigate,useLocation  } from 'react-router-dom';
import Contaier from "../../components/layout/Container/Container";
import { useConfig } from "../../context/ConfigProvider";
import { IResetPassword } from '../../typings/models/ResetPassword';
import { defaultAppContextData } from "../../services/appData";
import { useApiService, useContextService } from "../../services";
import { notify } from '../../utils';
import { NotifyType, PageUrl } from '../../utils/app-config';
import Loader from '../../components/molecules/Loader';
import ReCAPTCHA from "react-google-recaptcha";
import { setRecaptchaRef } from "../../services/axiosconfig";

function ResetPassword() {   
  const cfg = useConfig();
  const site_Key: string = cfg.REACT_APP_SITE_KEY ?? "";
  const navigate = useNavigate();
  const { ValidateResetPasswordToken,ResetPassword } = useApiService();
  const { getContextValueFromStorage } = useContextService();
  const [contextData] = useState(() =>
    getContextValueFromStorage(defaultAppContextData)
  );
  const [loading, setLoading] = useState(false);
  const [confirmPasswordError, setConfirmPasswordError] = useState("");
  const [newPasswordError, setNewPasswordError] = useState("");
  const [isButtonEnabled, setIsButtonEnabled] = useState(false);
  const { message } = notify();
  const user = contextData.user;
  const { register, handleSubmit, formState: { errors } } = useForm<IResetPassword>();
  const [isTokenValid, setIsTokenValid] = useState<boolean | undefined>(undefined);
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const token = queryParams.get('token');
  const hasValidated = useRef(false);
  const [isCaptchaValid, setIsCaptchaValid] = useState(false);
  const recaptchaRef = useRef<ReCAPTCHA>(null);
  useEffect(() => {
      setRecaptchaRef(recaptchaRef); // 🔗 give Axios access to the reCAPTCHA
    }, []);
  useEffect(() => {    
    const validateToken = async () => {
      // Prevent re-validation
      if (hasValidated.current) return;
      hasValidated.current = true;
  
      if (!token) {
        message(NotifyType.Error, "Reset link is missing.");
        setIsTokenValid(false);
        return;
      }
  
      try {
        let status = await ValidateResetPasswordToken(token);
        if (status && status==true) {
          setIsTokenValid(true);
        } else {
            message(NotifyType.Error, "Reset link is invalid or expired.");
          setIsTokenValid(false);
        }
      } catch (error) {
        message(NotifyType.Error, "Something went wrong validating the reset link.");
        setIsTokenValid(false);
      }
    };
  
    validateToken();
  }, [token]);

  const handleNewPasswordChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = event.target;
    const uppercaseRegExp   = /(?=.*?[A-Z])/;
    const lowercaseRegExp   = /(?=.*?[a-z])/;
    const digitsRegExp      = /(?=.*?[0-9])/;
    const specialCharRegExp = /(?=.*?[#?!@$%^&*-])/;
    const minLengthRegExp   = /.{8,}/;
    const passwordLength =      value.length;
    const uppercasePassword =   uppercaseRegExp.test(value);
    const lowercasePassword =   lowercaseRegExp.test(value);
    const digitsPassword =      digitsRegExp.test(value);
    const specialCharPassword = specialCharRegExp.test(value);
    const minLengthPassword =   minLengthRegExp.test(value);
    let errMsg ="";
    if(passwordLength===0){
            errMsg="Password is empty";
            setIsButtonEnabled(false);
    }else if(!uppercasePassword){
            errMsg="At least one Uppercase";
            setIsButtonEnabled(false);
    }else if(!lowercasePassword){
            errMsg="At least one Lowercase";
            setIsButtonEnabled(false);
    }else if(!digitsPassword){
            errMsg="At least one digit";
            setIsButtonEnabled(false);
    }else if(!specialCharPassword){
            errMsg="At least one Special Characters";
            setIsButtonEnabled(false);
    }else if(!minLengthPassword){
            errMsg="At least minumum 8 characters";
            setIsButtonEnabled(false);
    }else{
        errMsg="";
        setIsButtonEnabled(true);
    }

    setNewPasswordError(errMsg);    
  };

  const handleConfirmPasswordChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = event.target;
    const uppercaseRegExp   = /(?=.*?[A-Z])/;
    const lowercaseRegExp   = /(?=.*?[a-z])/;
    const digitsRegExp      = /(?=.*?[0-9])/;
    const specialCharRegExp = /(?=.*?[#?!@$%^&*-])/;
    const minLengthRegExp   = /.{8,}/;
    const passwordLength =      value.length;
    const uppercasePassword =   uppercaseRegExp.test(value);
    const lowercasePassword =   lowercaseRegExp.test(value);
    const digitsPassword =      digitsRegExp.test(value);
    const specialCharPassword = specialCharRegExp.test(value);
    const minLengthPassword =   minLengthRegExp.test(value);
    let errMsg ="";
    if(passwordLength===0){
            errMsg="Password is empty";
            setIsButtonEnabled(false);
    }else if(!uppercasePassword){
            errMsg="At least one Uppercase";
            setIsButtonEnabled(false);
    }else if(!lowercasePassword){
            errMsg="At least one Lowercase";
            setIsButtonEnabled(false);
    }else if(!digitsPassword){
            errMsg="At least one digit";
            setIsButtonEnabled(false);
    }else if(!specialCharPassword){
            errMsg="At least one Special Characters";
            setIsButtonEnabled(false);
    }else if(!minLengthPassword){
            errMsg="At least minumum 8 characters";
            setIsButtonEnabled(false);
    }else{
        errMsg="";
        setIsButtonEnabled(true);
    }

    setConfirmPasswordError(errMsg);    
  };

    const onClickLogin = async () => {             
        handleSubmit(async (password: IResetPassword) => {
            setLoading(true); 
            if (password?.NewPassword != password?.ConfirmNewPassword) {
                setConfirmPasswordError("Confirm password is not matched");
                setLoading(false);
                return;
            } 
            else
            {
                setConfirmPasswordError("");
            }
            const reCaptchaResponse = recaptchaRef.current?.getValue();
            if (!reCaptchaResponse) {
              setIsCaptchaValid(false);
              return;
            }
            password.Email = user?.email ?? '';
            password.UserId = user?.id ?? '';
            const token = queryParams.get('token');
            password.Token = token ?? '';
            let status = await ResetPassword(password);
            setLoading(false);
            if (status && status=="Success") {
                message(NotifyType.Success, "Password Updated Successfully");
                window.location.href = '/eservices/';
              } else {           
                setIsCaptchaValid(false);
                recaptchaRef?.current?.reset(); 
                message(NotifyType.Error, "User Authentication failed. Please try again.")
            }
        })()
    }
      return (
        <>
        {isTokenValid === undefined && <div>Checking reset link...</div>}
        {isTokenValid === false && (
      <div className="error-message">
        The reset link is invalid or has expired. Please request a new one.
      </div>
    )}
        {isTokenValid === true &&(
          <Contaier>
            <div className="inner-content">
              <div className="container">
                <div className="landing-page form-upload">
                  <div className="row justify-content-center">
                    <div className="col-md-7 col-lg-5">
                      <div className="landing-list py-5 rounded-4">
                        <h2 className="text-center mb-5">Change Password</h2>                       
                        <div className="mb-3">
                          <label
                            htmlFor="validationServer02"
                            className="form-label"
                          >
                            Create New Password
                          </label>
                          <input
                            type="password"
                            className="form-control"
                            placeholder="New Password"
                            id="NewPassword"
                            {...register("NewPassword", {
                              required: "Please enter new password",
                              onChange(event) {
                                handleNewPasswordChange(event);
                              },
                            })}
                          />
                          <ErrorMessage
                            errors={errors}
                            name="NewPassword"
                            render={({ message }) => (
                              <p className="errorMsgPassword mb-0">{message}</p>
                            )}
                          />
                          <p className="errorMsgPassword mb-0">
                            {newPasswordError}
                          </p>
                        </div>
                        <div className="mb-3">
                          <label
                            htmlFor="validationServer03"
                            className="form-label"
                          >
                            Confirm New Password
                          </label>
                          <input
                            type="password"
                            className="form-control"
                            placeholder="Confirm New Password"
                            id="ConfirmNewPassword"
                            {...register("ConfirmNewPassword", {
                              required: "Please enter confirm new password",
                              onChange(event) {
                                handleConfirmPasswordChange(event);
                              },
                            })}
                          />
                          <ErrorMessage
                            errors={errors}
                            name="ConfirmNewPassword"
                            render={({ message }) => (
                              <p className="errorMsgPassword mb-0">{message}</p>
                            )}
                          />
                          <p className="errorMsgPassword mb-0">
                            {confirmPasswordError}
                          </p>
                        </div>
                        <div className="mb-3">
                        <ReCAPTCHA
                          ref={recaptchaRef}
                          sitekey={site_Key}
                          onChange={() => setIsCaptchaValid(true)}
                          onExpired={() => setIsCaptchaValid(false)}
                        />
                        {isButtonEnabled && !isCaptchaValid && (
                          <div className="error-message">
                            Please complete the reCAPTCHA verification.
                          </div>
                        )}
                      </div>
                        <div className="text-center">
                          <button
                            type="button"
                            disabled={!isButtonEnabled || loading}
                            onClick={onClickLogin}
                            className="btn btn-success mt-4"
                          >
                            {loading ? <Loader /> : <>Submit</>}
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Contaier>
)}
        </>
      );
}

export default ResetPassword;
